import React,{Component} from 'react';
import NavListAccordion, {NavListAccordionWrapper} from '../../../../common/NavListAccordion/NavListAccordion';
import {getCountryAccordions,dropDownDataSourceMap,accordionFieldsMap,paymentTypeNarrativeMap,objectToStringFieldMap} from '../../../ProductRequests/CaptureProductAchCredit/mappingFile';

import {Translations} from '../../../../../utils';
import {eapiClient, aemHostClient} from '../../../../../restClient';
import AchAccordion from './AchAccordion/AchAccordion';

import {FORM_REFS} from '../../../../../constants';

import './styles.css';

export default class AchCredit extends Component {
  constructor(props) {
    super(props);
    this.state={
      pageJson : undefined,
      allAccordionAemData: undefined,
      checkboxTaxonomy: undefined
    }

  }

  setTranslatedDataFromTaxonomy=()=>{
    eapiClient(Translations(this.state.pageJson.par.aemform_creditTransferSpecific.creditTaxonomy,this.props.lang.currentLang.lang, this.props.lang.translatedData))
    .then(({data}) => {
    if(data.responseData !== undefined){
      this.setState({
        checkboxTaxonomy: data
      })
    }
    });
  }

  componentDidMount(){

    //Get the pageJSON for various accordions of ACH Credit
    aemHostClient("/aemData/formData/json_ach-credit-all-closed")
    .then(({data}) => {
        this.setState({pageJson: data},()=>{
          //Get the taxonomy to populate labels for checkboxes and radio buttons
          this.setTranslatedDataFromTaxonomy();

          let formDataObject = {};
          for(let [accordionKey,accordionContent] of Object.entries(this.state.pageJson.par)){
            if(accordionKey.startsWith('aemform_')){
              formDataObject[accordionContent.name]={formRef: FORM_REFS[accordionContent.formRef]}
            }
          }
          this.getAemAccordionComponents(formDataObject);
       });
    })
  }

  getAemAccordionComponents=(allAccordionPageJson)=>{
    let formRefUrlArray = [];
    let accordionNameObj = {};
    for(let [_key,_val] of Object.entries(allAccordionPageJson)){
      formRefUrlArray.push(_val.formRef);
      accordionNameObj[_key] = {};
    }
    let requests = formRefUrlArray.map(formRefUrl => aemHostClient(formRefUrl));
    Promise.all(requests)
      .then(responses=>{
        let responseCounter = 0;
        for(let accordionNameKey of Object.keys(accordionNameObj)){
            //accordionKey: response.guideContainer.rootPanel.items
            accordionNameObj[accordionNameKey] = responses[responseCounter].data.guideContainer.rootPanel.items;
            responseCounter++;
        }
        this.setState({
          allAccordionAemData: accordionNameObj
        });
      })
      .catch(err=>{console.log('An error occoured in ACHCredit: ',err)});
  }

  getPaymentType=(paymentObject)=>{
    if(paymentObject){
      let _splitId = paymentObject.value.split(':');
      return _splitId[_splitId.length-2].toLowerCase();
    }else{
      return undefined;
    }
  }

  renderAchCreditAccordion=(newAccounts , echannels, achCreditItem, pageJson)=>{
    let achCreditPaymentType = this.getPaymentType(achCreditItem.paymentType||undefined);
    let achCreditAccordionList = getCountryAccordions((achCreditItem.country.value.split(':')[achCreditItem.country.value.split(':').length-2].split('-').join('').toLowerCase()) + (achCreditPaymentType?`_${achCreditPaymentType}`:''));
    let _achCreditAccordionJsx = [];

    let _additionalDetailsObject = {
      country: achCreditItem.country || undefined,
      productOwner: achCreditItem.productOwner || undefined,
      otherAccounts: achCreditItem.otherAccounts || undefined,
      paymentType: achCreditPaymentType
    }

    if(achCreditAccordionList && achCreditAccordionList.length > 0){
      for(let achCrAccordion of achCreditAccordionList){
        if(achCreditItem[achCrAccordion] && typeof achCreditItem[achCrAccordion]==='object' && this.state.checkboxTaxonomy !== undefined  ){
          _achCreditAccordionJsx.push(<AchAccordion
                                        accordionName = {achCrAccordion}
                                        accordionData = {achCreditItem[achCrAccordion]}
                                        addDetails = {_additionalDetailsObject}
                                        accordionAemData={this.state.allAccordionAemData[achCrAccordion]}
                                        newAccounts = {newAccounts}
                                        echannels = {echannels}
                                        lang = {this.props.lang}
                                        key = {achCrAccordion}
                                        taxonomyData={this.state.checkboxTaxonomy}
                                        productReferenceObjects={this.props.productCountryList ? this.getProductCountryTaxanomy(this.props.productReferenceObjects): this.props.productReferenceObjects}
                                        title={this.state.pageJson}
                                      />);
        }
      }
    };

    return _achCreditAccordionJsx;
  }

  getProductCountryTaxanomy = (products) => {
    if (products !== undefined) {
      products = products.map(item => {
        this.props.productCountryList.filter(countItem => {
          if ('country' in item) {
            if (countItem.id === item.country.value) {
              item.country.name = countItem.name
              } }
        });
        return item;
      });
      return products;
}
}

  getCountryTaxanomy = (val) => {
    let countryList = this.props.countryList;
    if (val !== undefined && countryList !== undefined) {
      let countryItem = countryList.find(x => x.id === val);
      if (countryItem !== undefined) {
        let countryName = countryItem.name;
        return countryName;
      }
    }
  }

  getPaymentTypeName = (val) => {
    let countryList = this.props.countryList;
    if (val !== undefined && val.country !== undefined && countryList !== undefined) {
      let countryItem = countryList.find(x => x.id === val.country.value);
      if (countryItem !== undefined) {
        let paymentType = countryItem.associations.find(x => x.id === val.paymentType.value);
        if(paymentType !== undefined){
          let paymentTypeName = paymentType.name;
          return paymentTypeName;
        }
      }
    }
  }

  renderAchCreditProducts=(newAccounts , echannels, newAchCredit, pageJson)=>{
    let _achCreditProductMainJsx=[];

    if(newAchCredit && newAchCredit.length > 0 ){
      _achCreditProductMainJsx = newAchCredit.map((achCreditItem,key)=>{
          let tabTitleHtml = (<div>
                                <div className="Title">
                                {`${achCreditItem.country? this.getCountryTaxanomy(achCreditItem.country.value):''}${achCreditItem.paymentType? ', '+this.getPaymentTypeName(achCreditItem):'' }`}
                                </div>
                                <div  className="SubTitle">
                                {`${achCreditItem.achAgent? achCreditItem.achAgent.name:''}`}
                                </div>
                              </div>);

          return (
              <NavListAccordion navAccHeading={tabTitleHtml} key={key}>
              <div className="basic-details-section">
                {this.renderAchCreditAccordion(newAccounts , echannels, achCreditItem, pageJson)}
              </div>
              </NavListAccordion>
          )
      })
    }

    return _achCreditProductMainJsx;

  }


  render(){
    const  {newAccounts , echannels, newAchCredit, pageJson} = this.props;
    return(
      <div className="gdoc-preview-request-content">
      <span>
      {Translations(pageJson.dynamic_accordion_list_achCredits.title,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
      </span>
      {this.state.allAccordionAemData?(
        <NavListAccordionWrapper>
          {this.renderAchCreditProducts(newAccounts , echannels, newAchCredit, pageJson)}
        </NavListAccordionWrapper>
      ):''}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/PreviewRequest/Child/AchCredit/AchCredit.js